// Frontend validation utilities

export const REGEX = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  // Allow digits, optional +, spaces, dashes, parentheses
  PHONE: /^\+?[\d\s\-()]{6,20}$/,
  // E.164-without-+ digits only, 8–15 digits
  WHATSAPP: /^\d{8,15}$/,
  // Loose URL — http(s) required
  URL: /^https?:\/\/[\w.-]+(?:\.[\w.-]+)+[\w\-._~:/?#[\]@!$&'()*+,;=.]+$/i,
  // Slug — kebab-case
  SLUG: /^[a-z0-9]+(?:-[a-z0-9]+)*$/,
  // Letters and spaces only (names)
  LETTERS_AND_SPACES: /^[\p{L}\p{M}'\- .]{1,80}$/u,
};

export const validators = {
  required: (v) => (v == null || String(v).trim() === "") ? "Required" : "",
  email: (v) => v && !REGEX.EMAIL.test(v) ? "Invalid email" : "",
  phone: (v) => v && !REGEX.PHONE.test(v) ? "Phone must contain only digits, +, spaces, dashes" : "",
  whatsapp: (v) => v && !REGEX.WHATSAPP.test(v) ? "WhatsApp must be 8–15 digits only (no +)" : "",
  url: (v) => v && !REGEX.URL.test(v) ? "URL must start with http:// or https://" : "",
  minLen: (n) => (v) => v && String(v).trim().length < n ? `Min ${n} characters` : "",
  maxLen: (n) => (v) => v && String(v).length > n ? `Max ${n} characters` : "",
  numeric: (v) => v && !/^\d+$/.test(String(v)) ? "Digits only" : "",
  integer: (v) => v && !/^-?\d+$/.test(String(v)) ? "Whole number only" : "",
  noLetters: (v) => v && /[A-Za-z]/.test(v) ? "No letters allowed" : "",
  slug: (v) => v && !REGEX.SLUG.test(v) ? "Lowercase letters, digits and dashes only" : "",
};

export const runValidators = (value, fns = []) => {
  for (const fn of fns) {
    const err = fn(value);
    if (err) return err;
  }
  return "";
};

// Filter input as the user types (e.g. strip non-digits)
export const sanitizers = {
  digitsOnly: (v) => String(v ?? "").replace(/\D/g, ""),
  phoneAllowed: (v) => String(v ?? "").replace(/[^\d+\-\s()]/g, ""),
  trimSpaces: (v) => String(v ?? "").replace(/\s+/g, " ").trim(),
};
